module.exports = __webpack_public_path__ + "/login_ui/img/lt-b40a2987fd72892fd7b02116faa7a305.svg";